import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import styled, { css } from 'styled-components';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import faLightbulb from '@fortawesome/fontawesome-free-solid/faLightbulb';
import faClose from '@fortawesome/fontawesome-free-solid/faTimes';

const Toggler = styled.div`
  position: fixed;
  width: 60px;
  height: 60px;
  right: 25px;
  bottom: 25px;
  opacity:0;
  -webkit-transition: opacity .1s ease-in-out,-webkit-transform .1s ease-in-out;
  transition: opacity .1s ease-in-out,-webkit-transform .1s ease-in-out;
  -o-transition: opacity .1s ease-in-out,transform .1s ease-in-out;
  transition: opacity .1s ease-in-out,transform .1s ease-in-out;
  transition: opacity .1s ease-in-out,transform .1s ease-in-out,-webkit-transform .1s ease-in-out;
  background: #000;
  color:#fff;
  border-radius:50%;
  -webkit-box-shadow: 0 0 27px 1.5px rgba(0,0,0,.2);
  box-shadow: 0 0 27px 1.5px rgba(0,0,0,.2);

  ${props => props.active && css`
      opacity:1;
  `}

  @media print {
    display: none;
  }

`;

const Icon = styled(FontAwesomeIcon)`
   margin-left:50%;
   margin-top:50%;
   transform:translateX(-50%) translateY(-50%);
   font-size:30px;
`;

class Launcher extends Component {
  insightActive(match) {
    return match.params && match.params.report;
  }
  clickedToggler(match) {
    match.params && match.params.report ? this.props.history.push(this.active(match).history):this.props.history.push(this.active(match).path);
  }
  active(match) {
    const paths = ["/"];
    //const views = ["price"];
    const views = [];
    let active = false;
    let path = "/";
    let history = "/";

    // INDEX PATH
    if (paths.indexOf(match.path) > -1) {
      active = true;
      path = "/insights/index";
      history = "/";
    }

    // P-VIEW WITH INSIGHTS
    if (match.params.view && views.indexOf(match.params.view) > -1) {
      active = true;
      path = "/insights/" + match.params.view;
      history = "/p/" + match.params.view;
    }

    // REPORT-VIEW
    if (match.params.report) {
      active = true;
      if (match.params.report ==='index') {
        history = "/";
      } else {
        history = "/p/" + match.params.report;
      }
    }

    return {active: active, path: path, history: history};
  }
  render() {
      const { match } = this.props;

      return (
        <Toggler active={this.active(match).active} onClick={() => this.clickedToggler(match)}>{this.insightActive(match) ? <Icon icon={faClose} />:<Icon icon={faLightbulb} />}</Toggler>
      )
  }
}

function mapStateToProps(state) {
  return {
      user: state.user
  };
}

export default withRouter(connect(mapStateToProps, {})(Launcher));



// WEBPACK FOOTER //
// ./src/components/dataViews/insights/Launcher.js